import * as React from "react";
import { connect, HandleThunkActionCreator } from "react-redux";
import { useParams } from "react-router-dom";
import { forbiddenError, notFoundError } from "../../../actions/common/errors";
import BackLink from "../../../components/atoms/BackLink/index";
import { BlockRow } from "../../../components/atoms/BlockRow/index";
import Loader from "../../../components/atoms/Loader";
import {
  MainSection,
  PageHeader,
} from "../../../components/atoms/MainSection/index";
import { StudentTagFilterInterface } from "../../../domains/StudentTag";
import { OutletContextProps } from "../../../helpers/RouterHelper";
import enhanceSectionsSettingsPage, {
  SectionsSettingsPageProps,
} from "../../../hocs/enhanceSectionsSettingsPage";
import SectionInterface from "../../../interfaces/SectionInterface";
import { ContentVideoForm } from "./ContentVideoForm";
import { useIndex } from "./useIndex";

type Props = SectionsSettingsPageProps &
  OutletContextProps & {
    section: SectionInterface;
    tagFilter: StudentTagFilterInterface;
    notFoundError: HandleThunkActionCreator<typeof notFoundError>;
    forbiddenError: HandleThunkActionCreator<typeof forbiddenError>;
  };

// eslint-disable-next-line
const SectionsSettingsContentVideosNewOrEditPage_: React.FC<Props> = (
  props,
) => {
  React.useEffect(() => {
    props.setActiveMenu("courses");
  }, []);
  const { contentId } = useParams<{ contentId?: string }>();
  const state = useIndex({
    section: props.section,
    navigate: props.navigate,
    showErrorFlashMessage: props.showErrorFlashMessage,
    showSuccessFlashMessage: props.showSuccessFlashMessage,
    onNotFoundContent: props.notFoundError,
    onForbiddenContent: props.forbiddenError,
    contentId: contentId ?? null,
  });

  return (
    <>
      <BackLink path={`/sections/${props.section.id}/settings/contents`}>
        戻る
      </BackLink>
      <BlockRow marginTop="2.4rem">
        <MainSection>
          <PageHeader helpUrl="https://fs-help.studyplus.co.jp/ja/articles/4964874">
            {contentId ? "動画のURLの編集" : "動画のURLの登録"}
          </PageHeader>
          <BlockRow marginTop="1.6rem">
            {state.status === "ReadyUserInput" && (
              <ContentVideoForm
                initialContent={state.data ?? null}
                onSubmit={state.handleSubmit}
                isLoading={state.isLoading}
                isNew={state.isNew}
              />
            )}
          </BlockRow>
          <Loader loading={state.status === "LoadingContent"} />
        </MainSection>
      </BlockRow>
    </>
  );
};
const pageInfo = {
  title: "動画のURLの登録",
};

const actions = {
  notFoundError,
  forbiddenError,
};

export const SectionsSettingsContentVideosNewOrEditPage =
  enhanceSectionsSettingsPage(
    connect(null, actions)(SectionsSettingsContentVideosNewOrEditPage_),
    pageInfo,
  );
